import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import { css } from "styled-components";
import { StyledImageContainer } from "../../../components/ModalComponents/StyledModalComponents";
import { currentlyEditingSleeperSelector } from "../../../redux/slices/customNavigation";
import { getAdaptiveFontSize } from "../../../utils/styling.utils";
import { getFinalEvrScore } from "../../../utils/evrscore.utils";
import {
  isSingleSleeperSelector,
  primarySleeperFirstNameSelector,
  secondarySleeperFirstNameSelector,
} from "../../../redux/slices/mattressConfiguration";

import { useSelector } from "react-redux";
import TextTransition, { presets } from "react-text-transition";

import svg_background from "../../../assets/images/Path_7821.png";

import useMediaQuery from "@mui/material/useMediaQuery";

const GlobalEvrScore = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);
  const primarySleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  const secondarySleeperFirstName = useSelector(
    secondarySleeperFirstNameSelector
  );
  const glow = css`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

  return (
    <div
      style={{
        position: "absolute",
        top: "2%",
        right: "500px",
        width: "200px",
        height: "200px",
        marginRight: "20px",
      }}
    >
      <StyledImageContainer className="">
        <img
          style={{
            width: "200px",
            height: "200px",
          }}
          src={svg_background}
        ></img>
      </StyledImageContainer>
      <div
        style={{
          position: "absolute",
          top: "42px",
          left: "50px",
          width: "130px",
          height: "50px",
          fontWeight: "bold",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: getAdaptiveFontSize({ screenWidthHooks, fontSize: 1 }),
        }}
      >
        {t(
          `${
            isSingleSleeper
              ? "Your"
              : currentlyEditingSleeper === 1
              ? primarySleeperFirstName + "'s"
              : secondarySleeperFirstName + "'s"
          } evr-index`
        )}
      </div>
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "0",
          width: "200px",
          height: "200px",
          // textDecoration: "underline",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: getAdaptiveFontSize({
            screenWidthHooks,
            fontSize: 4.5,
          }),
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextTransition
          text={getFinalEvrScore({
            isPrimarySleeper: isSingleSleeper || currentlyEditingSleeper === 1,
          })}
          noOverflow={true}
          springConfig={presets.wobbly}
        />
      </div>
    </div>
  );
};

export default GlobalEvrScore;
